// extracted by mini-css-extract-plugin
module.exports = {"recaptcha":"a10a3f92e9--recaptcha--30MnK"};